// extracted by mini-css-extract-plugin
export default {"maroon":"Heading-module--maroon--e4db8","yellow":"Heading-module--yellow--520e1","blue":"Heading-module--blue--c9f2e","red":"Heading-module--red--d2440"};